import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  recruiter: yup.string().required('The recruiter field is required'),
});
